<template>
  <transition name="slide-fade">
    <default-layout>
      <v-app>
        <v-app-bar app clipped-left elevate-on-scroll dark color="black" src="/images/myriam-zilles-KltoLK6Mk-g-unsplash.jpg" :bottom="$breakpoint.smAndDown">
          <template v-slot:img="{ props }">
            <v-img
              v-bind="props"
              gradient="to top right, rgba(19,84,22,.9), rgba(12,20,19,.8)"
            ></v-img>
          </template>
          <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
          <v-toolbar-title role="button" @click="goTo('/?redirect=' + route().current())" class="pl-0">
            <v-img src="/maskable_icon_x512.png" href="/" height="50px" width="50px"></v-img>
          </v-toolbar-title>
          <v-toolbar-items v-if="!$breakpoint.smAndDown">
            <v-btn small icon @click="goTo('/?redirect=' + route().current())" fab>
              <v-icon>home</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items v-if="can['dashboard.view']">
            <v-btn :icon="$vuetify.breakpoint.xs" :fab="$vuetify.breakpoint.xs" class="" text @click="goTo('/dashboard')">
              <span v-if="$vuetify.breakpoint.xs">
                <v-icon>dashboard</v-icon>
              </span>
              <span v-else>Dashboard</span>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-btn small icon @click="goTo('/reports')" fab>
              <v-icon>mdi-chart-areaspline</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon text small v-if="getPrevious" fab @click="goTo(getPrevious)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-btn @click.stop.prevent="reloadCurrent()" fab text small href="?reload=true" icon title="Reload current page">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items v-if="$breakpoint.smAndUp">
            <v-btn @click="_changeMode()" text small icon fab title="Toggle Dark Mode">
              <v-icon>mdi-theme-light-dark</v-icon>
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-menu bottom left offset-y  transition="fab-transition" :origin="$breakpoint.smAndDown ? 'bottom right' : 'top right'">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" small fab>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="_changeMode()" title="Toggle Dark Mode" v-if="!$breakpoint.smAndUp">
                  <v-list-item-icon>
                    <v-icon>mdi-theme-light-dark</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Toggle Dark Mode</v-list-item-title>
                    <v-list-item-subtitle>Change between dark mode and light mode</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-subheader>Manage Account - {{ $page.props.user.name }}</v-subheader>
                <v-list-item :href="route('profile.show')" @click.stop.prevent="goTo(route('profile.show'))">
                  <v-list-item-avatar>
                    <v-img :src="$user.profile_photo_url"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>View Profile</v-list-item-title>
                    <v-list-item-subtitle>Change password, enable 2FA, etc</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="$page.props.jetstream.canCreateTeams">
                  <v-list-item-content>
                    <inertia-link :href="route('teams.create')">Create New Team</inertia-link>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="logout">
                  <v-list-item-avatar>
                    <v-icon>fa-sign-out</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>Logout</v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar-items>
        </v-app-bar>
        <v-navigation-drawer :bottom="$breakpoint.smAndDown" v-model="drawer" app clipped :temporary="$breakpoint.smAndDown" @click:outside="$breakpoint.smAndDown ? drawer = false : ''">
          <v-list nav dense>
            <inertia-link as="v-list-item" @click.stop="$breakpoint.smAndDown ? drawer = false : ''" href="/reports">
              <v-list-item-icon>
                <v-icon>mdi-chart-areaspline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item-content>
            </inertia-link>
            <v-spacer></v-spacer>
            <inertia-link as="v-list-item" v-for="uri in mylinks" :key="uri.path" :href="uri.path" :title="uri.title" v-show="can[uri.permission]" @click.stop="$breakpoint.smAndDown ? drawer = false : ''">
              <v-list-item-icon>
                <v-icon :color="uri.color == 'default' ? 'orange' : uri.color">{{ uri.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ uri.name }}</v-list-item-title>
              </v-list-item-content>
            </inertia-link>
            <v-spacer></v-spacer>
            <inertia-link as="v-list-item" href="/admin" title="Admin" v-if="$admin">
              <v-list-item-icon>
                <v-icon color="red">security</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Admin</v-list-item-title>
              </v-list-item-content>
            </inertia-link>
          </v-list>
          <template v-slot:append>
            <div class="pa-2 pull-right hidden-xs">
              <v-btn  small text @click="logout" class="tw-bg-blue-500 hover:tw-border-red-300">
                Logout
              </v-btn>
            </div>
          </template>
        </v-navigation-drawer>
        <v-main id="maincontent">
          <message-bar></message-bar>
          <transition name="slide-fade">
            <slot></slot>
          </transition>
          <!-- <permission-for-notifications/> -->
        </v-main>
      </v-app>
    </default-layout>
  </transition>
</template>

<script>
import PermissionForNotifications from '@/Mixins/PermissionForNotification'
import DefaultLayout from '@/Layouts/Default'
import VueCookie from 'vue-cookie'
import Vue from 'vue'
const MessageBar = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/messagebar')

Vue.use(VueCookie)

  export default {
    name: 'report-layout',
    components: {
      PermissionForNotifications,
      MessageBar,
      DefaultLayout,
    },
    metaInfo () {
      return {
        title: 'Dashboard'
      }
    },
    data () {
      return {
        drawer: true,
        mylinks: [
          {
            name: 'Service Requests',
            title: 'View Requests',
            path: '/reports/service_requests',
            permission: 'service_requests.index',
            color: 'default',
            icon: 'mdi-map-marker-plus-outline'
          },
          {
            name: 'Patient Visits',
            title: 'View Requests',
            path: '/reports/visits',
            permission: 'visits.view',
            color: 'default',
            icon: 'mdi-account-group'
          },
          {
            name: 'User Referrals',
            title: 'View User Referrals',
            path: '/user-referrals',
            permission: 'referrals.view',
            color: 'default',
            icon: 'mdi-account-group'
          },
        ]
      }
    },
    methods: {
      logout () {
        this.$cookie.set('loggedout', true, { expires: '1D' })
        this.$inertia.post('/logout')
      },
      getprofile () {
        this.$inertia.visit('/user/profile')
      },
      goToLink (url) {
        this.$inertia.visit(url)
      },
      reloadCurrent () {
        this.$inertia.reload({ preserveScroll: true, preserveState: false })
      }
    },
    mounted () {
      this.$nextTick(() => {
        var cookie = this.$cookie.get('loggedout')
        if (cookie) {
          this.$cookie.delete('loggedout')
        }
      })
    },
  }
</script>
<style>
  .hidden {
    display: none;
  }
  [role="button"] {
    cursor: pointer;
  }
  @media screen and (min-width: 703px) {
    .v-dialog:not(.v-dialog--fullscreen) {
      max-width: 60vw;
    }
  }
  .v-dialog > .v-card > .v-card__text {
    padding: 1px;
  }
  .v-dialog {
    margin: 5px;
  }
  .v-card__title.primary {
    color: white;
  }
</style>
